export enum ProjectVerticalsEnum {
  BUILDING = 'BUILDING',
  HOME = 'HOME',
  HOTEL = 'HOTEL',
  HOTEL_ROOM = 'HOTEL_ROOM',
  OFFICE = 'OFFICE',
  PARKING_SLOT = 'PARKING_SLOT',
  RENT = 'RENT',
  VACATIONAL_RENTAL = 'VACATIONAL_RENTAL',
}